import type { RootState } from "./store";

// --- Simple Selectors ---
export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;

export const selectIsLoadingAuth = (state: RootState) =>
  state.auth.isLoadingAuth;

// --- User Data Selectors ---
export const selectUser = (state: RootState) => state.auth.user;

export const selectFullName = (state: RootState) => {
  const user = state.auth.user;
  if (!user) return null;
  return `${user.firstName} ${user.surname}`;
};

export const selectJobPosition = (state: RootState) =>
  state.auth.user?.jobPosition;

export const selectUserEmail = (state: RootState) =>
  state.auth.user?.email || null;

// --- Onboarding Selectors ---

export const selectOnboardingStep = (state: RootState) =>
  state.auth.user?.onboardingStep;

export const selectIsOnboardingComplete = (state: RootState) =>
  state.auth.user?.onboardingStep === 2;

// --- Meet Data Selectors (Deep Access) ---

export const selectMeetStatus = (state: RootState) =>
  state.auth.user?.meetStatus;

export const selectIsFeatureEnabled = (state: RootState) =>
  state.auth.user?.meetStatus !== "pending" &&
  state.auth.user?.onboardingStep === 2;

export const selectMeetData = (state: RootState) => state.auth.user?.meetData;

export const selectMeetingName = (state: RootState) =>
  state.auth.user?.meetData?.name;

export const selectEventMemberships = (state: RootState) =>
  state.auth.user?.meetData?.eventMemberships || [];

// --- Company Data Selectors ---

export const selectUserCompanies = (state: RootState) =>
  state.auth.user?.companies || [];

export const selectPrimaryCompany = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0 ? companies[0] : null;
};

export const selectLastPeriodRegistered = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0
    ? companies[0]?.lastPeriodRegistered
    : null;
};

export const selectPrimaryCompanyCurrency = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0
    ? companies[0]?.primaryCurrency
    : null;
};

export const selectDefaultTrimestralPeriod = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0
    ? companies[0]?.defaultTrimestralPeriod
    : null;
};

export const selectDefaultAnualPeriod = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0
    ? companies[0]?.defaultAnualPeriod
    : null;
};

export const selectPreferredUnitType = (state: RootState) => {
  const companies = state.auth.user?.companies;
  return companies && companies.length > 0
    ? companies[0]?.preferredUnitType
    : null;
};
